import { Action, Reducer } from 'redux';
import {
  DamageAreaState,
  DamageAreaTypes,
  DamageAreaActionTypes
} from './damageAreaTypes';

export const INITIAL_STATE: DamageAreaState = {
  damageAreas: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const damageAreaReducer: Reducer<DamageAreaState> = (
  state: DamageAreaState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as DamageAreaActionTypes;
  switch (actionTypes.type) {
    case DamageAreaTypes.GET_DAMAGEAREAS:
      return {
        ...state,
        damageAreas: { ...state.damageAreas, isLoading: true }
      };
    case DamageAreaTypes.SAVE_DAMAGEAREAS:
      return {
        ...state,
        damageAreas: {
          ...state.damageAreas,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case DamageAreaTypes.RESET_REDUCER_DAMAGEAREAS:
      return {
        ...state,
        damageAreas: INITIAL_STATE.damageAreas
      };
    default:
      return state;
  }
};

export default damageAreaReducer;
